import { useState, useEffect } from "react";
import LanguageSelector from "./LanguageSelector";

// Navigation Component - Mobile Optimized
const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navLinks = [
    { href: "#inicio", label: "Inicio" },
    { href: "#reservar", label: "Reservar" },
    { href: "#servicios", label: "Servicios" },
    { href: "#flota", label: "Flota" },
    { href: "#recomendaciones", label: "Recomendaciones" },
    { href: "#contacto", label: "Contacto" }
  ];

  return (
    <>
      <nav
        data-testid="main-navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled ? "bg-[#0f0f1a]/95 backdrop-blur-md py-3 shadow-lg" : "bg-gradient-to-b from-[#0f0f1a]/80 to-transparent py-4"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <a href="#inicio" className="flex items-center gap-3 relative z-[60]" data-testid="logo-link">
              <img 
                src="https://customer-assets.emergentagent.com/job_b5bd5f4a-d504-46bf-ad61-768b78dda5bc/artifacts/kjapaj5e_image.png" 
                alt="Transfer del Sur Logo" 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover flex-shrink-0 shadow-lg"
              />
              <div>
                <h1 className="text-base sm:text-lg font-semibold text-white tracking-wider notranslate" style={{ fontFamily: "'Cinzel', serif" }}>
                  TRANSFER DEL SUR
                </h1>
                <p className="text-[9px] sm:text-[10px] text-[#c9a962] tracking-[3px] uppercase notranslate">Costa del Sol</p>
              </div>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-6">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-gray-300 hover:text-[#c9a962] transition-colors duration-300 tracking-wide uppercase"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "11px", letterSpacing: "1px" }}
                  data-testid={`nav-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              ))}
              
              {/* Language Selector */}
              <LanguageSelector />
              
              <a
                href="tel:+34600221794"
                className="btn-primary flex items-center gap-2 ml-2"
                data-testid="nav-phone-btn"
              >
                <i className="fas fa-phone"></i>
                <span>+34 600 221 794</span>
              </a>
            </div>

            {/* Mobile: Language + Menu Button */}
            <div className="lg:hidden flex items-center gap-2">
              <LanguageSelector />
              <button
                className="text-white text-xl p-2 relative z-[60]"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                data-testid="mobile-menu-btn"
                aria-label="Toggle menu"
              >
                <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu - Full Screen Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 z-[55] flex flex-col items-center justify-center"
          style={{ backgroundColor: '#0f0f1a' }}
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-2xl text-gray-200 hover:text-[#c9a962] transition-colors py-3 tracking-wider"
              style={{ fontFamily: "'Cinzel', serif" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+34600221794"
            className="btn-primary inline-flex items-center gap-2 mt-8"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <i className="fas fa-phone"></i>
            <span>+34 600 221 794</span>
          </a>
        </div>
      )}
    </>
  );
};

export default Navigation;
